<mat-toolbar *ngIf="currentUser | async" color="primary" class="py-toolbar">
  <img hr src="assets/py-logo-horizontal.png" alt="Pidelo Ya!" class="logo" />
  <button mat-button color="primary" [routerLink]="['/']">Home</button>
  <span class="spacer"></span>
  <button mat-flat-button color="accent" [routerLink]="['orders']">
    ORDERS
  </button>
</mat-toolbar>
<router-outlet></router-outlet>
